<header id="main_header" class="fixedHeader" data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1000">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <nav class="navbar navbar-expand-xl navbar-light">
                    <a class="navbar-brand" [routerLink]="['/']" routerLinkActive="active">
                        <!-- <img src="../../../assets/images/trinka-logo.png" /> -->
                        <img src="../../../assets/images/trinka_logo.svg" alt="trinka logo">
                    </a>

                    <div class="mobile_buttons">
                        <button class="mobile_try_a_demo_button">Try A Demo</button>
                        <a class="mobile_login" href="https://cloud.trinka.ai" target="_blank">
                            <span>무료 가입
                                <!-- <span class="small_mobile_only">for Free</span> -->
                            </span>
                            <i class="fa fa-sign-in" aria-hidden="true"></i>
                        </a>
                        <a class="mobile_login" href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">
                            <span class="diplay_none_for_icons">로그인</span>
                            <i class="fa fa-sign-in display_block_for_text" aria-hidden="true"></i>
                        </a>

                        <div class="navbar-nav ml-auto loginarea">

                        </div>

                        <button type="button" class="navbar-toggler" id="mobile_menu_toggle" data-toggle="collapse" data-target="#navbarCollapse">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 384.97 384.97" style="enable-background:new 0 0 384.97 384.97;" xml:space="preserve">
                                <g>
                                    <g id="Menu_1_">
                                        <path d="M12.03,120.303h360.909c6.641,0,12.03-5.39,12.03-12.03c0-6.641-5.39-12.03-12.03-12.03H12.03
                         c-6.641,0-12.03,5.39-12.03,12.03C0,114.913,5.39,120.303,12.03,120.303z" />
                                        <path d="M372.939,180.455H12.03c-6.641,0-12.03,5.39-12.03,12.03s5.39,12.03,12.03,12.03h360.909c6.641,0,12.03-5.39,12.03-12.03
                         S379.58,180.455,372.939,180.455z" />
                                        <path d="M372.939,264.667H132.333c-6.641,0-12.03,5.39-12.03,12.03c0,6.641,5.39,12.03,12.03,12.03h240.606
                         c6.641,0,12.03-5.39,12.03-12.03C384.97,270.056,379.58,264.667,372.939,264.667z" />
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </button>
                        <div id="body_overlay_section"></div>
                    </div>

                    <div class="collapse navbar-collapse" id="navbarCollapse">
                        <ul class="navbar-nav mr-auto">

                            <!-- <li class="nav-item">
                                <a class="nav-link" [routerLink]="['']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">홈</a>
                            </li> -->
                            <li class="nav-item dropdown" id="main_sub_menus">
                                <a class="nav-link dropdown-toggle" href="" id="dropdown04" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    애플리케이션
                                    <i class="fa fa-caret-down" aria-hidden="true"></i>
                                </a>
                                <div class="dropdown-menu" id="Home_sub_menus" aria-labelledby="dropdown04">
                                    <a class="nav-link" [attr.href]="'/trinkacloud'" [routerLink]="['/trinkacloud']" routerLinkActive="active">
                                        <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud" style="height: 28px;"> 트링카 클라우드</a>

                                    <a class="nav-link" [attr.href]="'/wordplugin'" [routerLink]="['/wordplugin']" routerLinkActive="active">
                                        <img src="../../../assets/images/Others_App_MSWord.svg" alt="trinka ms word"> MS Word 플러그인</a>

                                    <a class="nav-link" [attr.href]="'/browser-plugin'" [routerLink]="['/browser-plugin']" routerLinkActive="active">
                                        <img src="../../../assets/images/other_Apps_browser.svg" alt="browser-icon" style="height: 28px;"> 브라우저 플러그인</a>
                                </div>
                            </li>
                            <!-- <li class="nav-item">
                                <a class="nav-link" [routerLink]="['/features']" routerLinkActive="active">기능</a>
                            </li> -->
                            <li class="nav-item dropdown" id="feature_main_sub_menus">
                                <a class="nav-link dropdown-toggle" [routerLink]="['/features']" id="dropdown05" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">기능
                                    <i class="fa fa-caret-down" aria-hidden="true"></i>
                                </a>
                                <div class="dropdown-menu" id="feature_sub_menus" aria-labelledby="dropdown05">
                                    <a class="nav-link" [routerLink]="['/features']" routerLinkActive="active">
                                        모든 기능
                                    </a>
                                    <a class="nav-link" [routerLink]="['/features/plagiarism-check']" routerLinkActive="active">
                                        표절 검사
                                    </a>
                                    <a class="nav-link" href="https://www.trinka.ai/kr/features/auto-file-edit" routerLinkActive="active">
                                        자동 파일 편집
                                    </a>
                                    <a class="nav-link" [routerLink]="['/features/latex-grammar-checker']" routerLinkActive="active">
                                        LaTeX 문법 검사기 <div class="beta-badge">NEW</div>
                                    </a>
                                    <a class="nav-link" [routerLink]="['/features/paraphraser']" routerLinkActive="active">
                                        Online Paraphraser <div class="beta-badge">NEW</div>
                                    </a>
                                    <a class="nav-link" href="https://www.trinka.ai/kr/features/publication-readiness-checks" routerLinkActive="active">
                                        출판 준비 체크
                                    </a>
                                    <a class="nav-link" [routerLink]="['/features/consistency-check']" routerLinkActive="active">
                                        일관성 체크
                                    </a>
                                    <a class="nav-link" [routerLink]="['/features/personal-dictionary']" routerLinkActive="active">
                                        개인용 사전
                                    </a>
                                    <a class="nav-link" [routerLink]="['/features/credits']" routerLinkActive="active">
                                        트링카 크레딧 안내
                                    </a>
                                </div>
                            </li>
                            <!-- <li class="nav-item">
                                <a class="nav-link" [routerLink]="['/examples']" routerLinkActive="active">샘플</a>
                            </li> -->
                            <li class="nav-item">
                                <a class="nav-link" [routerLink]="['/pricing']" routerLinkActive="active">가격</a>
                            </li>
                            <li class="nav-item dropdown" id="enterprise_main_sub_menus">
                                <a class="nav-link"  id="enterpriseMainMenu" [routerLink]="['/enterprise']" routerLinkActive="active">엔터프라이즈
                                    <i class="fa fa-caret-down" aria-hidden="true"></i>
                                </a>
                                <div class="dropdown-menu" id="enterprise_sub_menus" aria-labelledby="dropdown04">
                                    <a class="nav-link" [routerLink]="['/enterprise/life-sciences-medicine-and-pharma']" routerLinkActive="active">
                                        생명과학, 의학 및 제약
                                    </a>
                                    <a class="nav-link" [routerLink]="['/enterprise/language-services-publishing-and-media']" routerLinkActive="active">
                                        언어 서비스, 출판 및 미디어
                                    </a>
                                    <a class="nav-link" [routerLink]="['/enterprise/academic-institutions']" routerLinkActive="active">
                                        학술 기관
                                    </a>
                                    <a class="nav-link" [routerLink]="['/enterprise/k12-and-elearning']" routerLinkActive="active">
                                        K-12 및 E-러닝
                                    </a>
                                    <a class="nav-link" [routerLink]="['/enterprise/technology-platforms']" routerLinkActive="active">
                                        기술 플랫폼
                                    </a>
                                    <!-- <a class="nav-link"  [routerLink]="['/enterprise/grammar-checker-api']" routerLinkActive="active">
                                        API
                                    </a> -->
                                </div>
                            </li>
                            <li class="nav-item dropdown" id="resources_main_sub_menus">
                                <a class="nav-link" href="javascript:void(0)"  routerLinkActive="active">기타
                                    <i class="fa fa-caret-down" aria-hidden="true"></i>
                                </a>
                                <div class="dropdown-menu" id="resources_sub_menus" aria-labelledby="dropdown06" style="min-width: 200px;">
                                    <!-- <a class="nav-link" href="/free-proofreading-tools/">Proofreading Tools</a> -->
                                    <a class="nav-link" [routerLink]="['/grammar-checker']" routerLinkActive="active">
                                       문법 검사기/
                                    </a>
                                    <a class="nav-link" [routerLink]="['/paraphrasing-tool']" routerLinkActive="active">
                                        <span>온라인 의역 도구</span> <div class="beta-badge">NEW</div>
                                    </a>
                                    <a class="nav-link" [routerLink]="['/ai-content-detector']" routerLinkActive="active">
                                        <span>AI 콘텐츠 탐지기</span> <div class="beta-badge">NEW</div>
                                    </a>
                                    <a class="nav-link" [routerLink]="['/punctuation-checker']" routerLinkActive="active">
                                        구두점 검사기
                                    </a>
                                    <a class="nav-link" [routerLink]="['/spell-checker']" routerLinkActive="active">
                                        철자 검사기
                                    </a>
                                    <a class="nav-link" [routerLink]="['/sentence-checker']" routerLinkActive="active">
                                        문장 ​​검사기
                                    </a>
                                    <!-- <a class="nav-link" href="/essay-checker/">Essay Checker</a>
                                    <a class="nav-link" [routerLink]="['/medical-grammar-and-spelling-checker']" routerLinkActive="active">
                                        Medical Grammar Check
                                    </a>
                                    <a class="nav-link" [routerLink]="['/academic-phrasebank']" routerLinkActive="active">
                                        Academic Phrasebank
                                    </a>
                                    <a class="nav-link" [routerLink]="['/thesis-checker']" routerLinkActive="active">
                                        Thesis Checker
                                    </a> -->
                                </div>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="apiGrammarChecker" [routerLink]="['/enterprise/grammar-checker-api']" routerLinkActive="active">
                                    API
                                </a>
                            </li>
                            <!-- <li class="nav-item">
                                <a class="nav-link" [routerLink]="['/try-a-demo']" routerLinkActive="active">데모 체험</a>
                            </li> -->
                        </ul>
                        <div class="navbar-nav ml-auto loginarea">
                            <a class="nav-item nav-link login_buttons signup_buttons_new" href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">무료 가입 </a>
                            <a class="nav-item nav-link login_buttons login_buttons_new" href="https://cloud.trinka.ai/signin?_rg=KR" target="_blank">로그인 </a>
                        </div>
                    </div>

                    <!-- <div class="widgetUpdate">
                        <a class="changelogfy-widget" href="#">
                            <i class="fa fa-bell-o" aria-hidden="true"></i>
                            새소식
                            <lib-changelogfy selector=".changelogfy-widget"
                                appId="2bde15c8-f2f3-4e23-ab7a-1f3c76ee357d"></lib-changelogfy>
                        </a>
                    </div> -->
                    <!-- <div class="global_reach">
                        <a>Global Reach</a>
                        <div class="dropdown_section">
                            <ul>
                                <li><a href="http://uat.trinka.ai/jp/" target="_blank">Japan</a></li>
                                <li><a href="http://uat.trinka.ai/cn/" target="_blank">China</a></li>
                                <li><a>Korea</a></li>
                                <li><a href="http://uat.trinka.ai/tw/" target="_blank">Taiwan</a></li>
                                <li><a href="http://uat.trinka.ai/es/" target="_blank">Spanish</a></li>
                            </ul>
                        </div>
                    </div> -->

                    <!-- <div class="language_sections" id="languageDropDown">
                        <i class="fa fa-globe" aria-hidden="true"></i>
                        <span>한국어</span>
                        <ul class="drop">
                            <li>
                                <a href="http://uat.trinka.ai/">
                                    English
                                </a>
                            </li>
                            <li>
                                <a href="http://uat.trinka.ai/jp/">
                                    日本語
                                </a>
                            </li>
                            <li>
                                <a href="http://uat.trinka.ai/cn/">
                                    简体中文
                                </a>
                            </li>
                            <li>
                                <a href="http://uat.trinka.ai/tw/">
                                    繁体中文
                                </a>
                            </li>
                            <li class="selected">
                                <a>
                                    <i class="fa fa-check" aria-hidden="true"></i>
                                    한국어
                                </a>
                            </li>
                            <li>
                                <a href="http://uat.trinka.ai/es/">
                                    Español
                                </a>
                            </li>
                        </ul>
                    </div> -->

                    <!--This is for live-->

                    <div class="language_sections" id="languageDropDown">
                        <i class="fa fa-globe" aria-hidden="true"></i>
                        <span>한국어</span>
                        <ul class="drop">
                            <li>
                                <a href="https://www.trinka.ai/">
                                    English
                                </a>
                            </li>
                            <li>
                                <a href="https://www.trinka.ai/jp/">
                                    日本語
                                </a>
                            </li>
                            <li>
                                <a href="https://trinka.enago.cn/">
                                    简体中文
                                </a>
                            </li>
                            <li>
                                <a href="https://www.trinka.ai/tw/">
                                    繁体中文
                                </a>
                            </li>
                            <li class="selected">
                                <a>
                                    <i class="fa fa-check" aria-hidden="true"></i>
                                    한국어
                                </a>
                            </li>
                            <li>
                                <a href="https://www.trinka.ai/es/">
                                    Español
                                </a>
                            </li>
                            <li>
                                <a href="https://www.trinka.ai/pt/">
                                    Português
                                </a>
                            </li>
                        </ul>
                    </div>


                </nav>
            </div>
        </div>
    </div>
</header>